import type { HTMLAttributes } from 'react';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'neutral' | 'brand';
}

export function Badge({ tone = 'neutral', className = '', ...props }: BadgeProps) {
  const toneClasses =
    tone === 'brand'
      ? 'bg-[rgba(198,144,50,0.12)] border-border-brand'
      : 'bg-surface-2 text-text-secondary border-border';

  return (
    <span
      className={`inline-flex items-center rounded-pill border px-2 py-0.5 text-xs font-medium ${toneClasses} ${className}`}
      style={tone === 'brand' ? { color: 'var(--df-text-brand)' } : undefined}
      {...props}
    />
  );
}
